export default __webpack_public_path__ + "static/marker_image-6a61994cbe829895529a09b30834b361.webp";